import { type CreateTrackModel } from '@/shared/api'

export const MAX_FIELD_LENGTH: {
  [key in keyof Required<
    Pick<CreateTrackModel, 'name' | 'description'>
  >]: number
} = {
  name: 150,
  description: 2000,
}
